import { defineStore } from 'pinia'
import { Province } from '@/types/types'
import { ref, computed } from 'vue'
import { useStoreSyncer } from '@/composables/Store-syncer';

//Setup Store
export const useClimaticStore = defineStore('climatic', () => {
   const { fetchAll, allItems, loading, error } = useStoreSyncer('/climatic', 'climatic'); 

   const allSites = computed(()=>{
    return allItems.value;
   })


  //force fetch from backend
  async function fetchAllSites() {
    console.log('climatic store fetchAllSites()...from backend')
    return fetchAll();
    /*
    try{
      const response = await api.get('/climatic', api.FORCE_FETCH);
      allSites.value = await response.data.climatic;
      return allSites.value;
    }catch(error){
      console.error("climatic store error on fetchAllSites()..." + error);
      return null;
    }*/
  }

  /**
   * Get the nearest 'n' sites to the given location
   * @param province
   * @param lat
   * @param lon
   * @param n the number of sites to return
   * @returns
   */
  function getNearestSites(province: Province, lat: number, lon: number, n: number) {
    console.log('climatic store getNearestSites()...')
    if (allSites.value == null) {
      console.log('..allSites is null, not doing anything...')
      //await getAllSites();
      //await fetchAllSites()
    }
    if (!province || !lat || !lon) {
      return []
    }
    console.log('..lat = ' + lat + ', long = ' + lon + ', province =' + province)
    //const data = allSites.value

    const arr = allSites.value
      .filter((site) => site.province == province)
      .map((site) => {
        const siteLat = site.gps.lat
        const siteLon = site.gps.lon
        site.delta = Math.pow(Math.pow(siteLat - lat, 2) + Math.pow(siteLon - lon, 2), 0.5)
        //console.log("delta = " + site.delta);
        return site
      })
      .toSorted((a, b) => a.delta - b.delta)

    // console.log('site array = ' + arr);
    if (!n || n == 0 || n == 1) {
      return arr[0]
    } else {
      return arr.slice(0, n)
    }
  }

  return { allSites, fetchAllSites, getNearestSites } //, init }
})
